import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Store } from '@ngxs/store';
import { ToolbarSettingRemoteDto } from 'src/generated/swagger';
import { UserActionSettingBaseRemoteDto } from '../../../../../../../generated/signalR/user-action-setting-base-remote-dto';
import { PresentationType } from '../../../../../../samwebDescription/samweb/settings/presentationType';
import { UserActionTyp } from '../../../../../../samwebDescription/samweb/userActions/userActions';

export class ChangeToolbarPresentation {
   public static readonly type = '[ToolbarSettings] Change toolbar presentation';

   constructor(public brickInstanceId: string, public toolbarId: string, public presentationType: PresentationType) {}
}

export class AddNewActionToToolbar {
   public static readonly type = '[ToolbarSettings] Add new action to toolbar';

   constructor(public brickInstanceId: string, public toolbarId: string) {}
}

export class ChangeActionOrderForToolbar {
   public static readonly type = '[ToolbarSettings] Change action order for toolbar';

   constructor(public brickInstanceId: string, public toolbarId: string, public oldIndex: number, public newIndex: number) {}
}

export class ChangeActionTitleForToolbar {
   public static readonly type = '[ToolbarSettings] Change action title for toolbar';

   constructor(public brickInstanceId: string, public toolbarId: string, public actionId: string, public newTitle: string) {}
}

export class ChangeActionColorForToolbar {
   public static readonly type = '[ToolbarSettings] Change action color for toolbar';

   constructor(public brickInstanceId: string, public toolbarId: string, public actionId: string, public newColor: string) {}
}

export class ChangeActionIconForToolbar {
   public static readonly type = '[ToolbarSettings] Change action icon for toolbar';

   constructor(public brickInstanceId: string, public toolbarId: string, public actionId: string, public icon: IconDefinition) {}
}

export class ChangeActionTypeForToolbarAction {
   public static readonly type = '[ToolbarSettings] Set action type for toolbar';

   constructor(public brickInstanceId: string, public toolbarId: string, public actionId: string, public actionTyp: UserActionTyp) {}
}

export class RemoveActionForToolbar {
   public static readonly type = '[ToolbarSettings] Remove action for toolbar';

   constructor(public brickInstanceId: string, public toolbarId: string, public actionId: string) {}
}

export class ExecuteToolbarAction {
   public static readonly type = '[ToolbarSettings] Execute toolbar action';

   constructor(public brickInstanceId: string, public toolbarId: string, public actionId: string, public store: Store) {}
}

export class UserActionSettingChanged {
   public static readonly type = '[ToolbarSettings] User action setting changed';

   constructor(public brickInstanceId: string, public toolbarId: string, public actionId: string, public actionSetting: UserActionSettingBaseRemoteDto) {}
}

export class SetToolbarSettings {
   public static readonly type = '[ToolbarSettings] Set toolbar settings';

   constructor(public brickInstanceId: string, public toolbarId: string, public toolbarSettings: ToolbarSettingRemoteDto) {}
}
